import { FC, useEffect, useState } from "react"
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import './filtersmodal.css'
import { Calendar } from 'primereact/calendar';
import { AiFillDelete } from 'react-icons/ai'
import { AutoComplete } from 'primereact/autocomplete';
import { SelectButton } from 'primereact/selectbutton';
import { catchResponse, dateFormatter, getMonthInterval } from "../../../utils/helperFunctions";
import { getFilterOptionsByScenarioID, getSimulationComparision } from "../../../services/scenario-service";
import { Chip } from 'primereact/chip';
import { IFilterModel, IFilterScenario } from "../../../models/ScenarioModel";
import { error, success } from "../../../utils/notifications";
import { useParams } from "react-router-dom";
import { FiCommand } from "react-icons/fi";
import { BsFillFilterCircleFill } from 'react-icons/bs'
import { FaSquare } from "react-icons/fa";
import moment from "moment";


export const FiltersModal:FC<any> = (props):JSX.Element => {

    const { filtersMASTER,campaign,visible, setVisible,idScenario, filters, setFilters, setFiltersUsedCounter, filtersFlag, setFiltersFlag } = props

    const options = ['propio', 'ajeno'];

    const {id,id_compare}:any = useParams()
   
    const [itemsTransporte, setItemsTransporte] = useState<any[]>([]);

    const [filteredItemsTransporte, setFilteredItemsTransporte] = useState<any[]>([])

    const [itemsPajera, setItemsPajera] = useState<any[]>([]);

    const [filteredItemsPajera, setFilteredItemsPajera] = useState<any[]>([])

    const [loadingApplyFilters, setLoadingApplyFilters] = useState<boolean>(false)

    const [loadingDeleteFilters, setLoadingDeleteFilters] = useState<boolean>(false)

    const [fechaMinima, setFechaMinima] = useState<any>(null);
    const [fechaMinimaTo, setFechaMinimaTo] = useState<any>(null)
    const [fechaMaxima, setFechaMaxima] = useState<any>(null);

    useEffect(() => {
        // Verificar que el rango de años tiene dos elementos
        if (campaign && campaign.length === 2) {
            // Calcular la fecha mínima al 1 de agosto del primer año
            const primerAnio = campaign[0];
            
            setFechaMinima(new Date(primerAnio, 7, 1)); // El mes 7 corresponde a agosto

            // Calcular la fecha máxima al último día de julio del segundo año
            const segundoAnio = campaign[1];
            setFechaMaxima(new Date(segundoAnio, 7, 0)); // El día 0 corresponde al último día del mes anterior (julio)
        }

    }, [campaign])

    
    const [selectedPajera, setSelectedPajera] = useState<any>(null);
    const [selectedPajeras, setSelectedPajeras] = useState<any[]>([]);
   
    const [selectedTransporte, setSelectedTransporte] = useState<any>(null);
    const [selectedTransportes, setSelectedTransportes] = useState<any[]>([]);

    const searchPajera = (event:any) => {
        // Timeout to emulate a network connection
        setTimeout(() => {
            let _filteredCountries;

            if (!event.query.trim().length) {
                _filteredCountries = [...filteredItemsPajera];
            }
            else {
                _filteredCountries = itemsPajera.filter((pajera:any) => {
                    return pajera.name.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredItemsPajera(_filteredCountries);
        }, 250);
    }

    const searchTransporte = (event:any) => {
        // Timeout to emulate a network connection
        setTimeout(() => {
            let _filteredTransportes;

            if (!event.query.trim().length) {
                _filteredTransportes = [...filteredItemsTransporte];
            }
            else {
                _filteredTransportes = itemsTransporte.filter((transporte:any) => {
                    return transporte.name.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredItemsTransporte(_filteredTransportes);
        }, 250);
    }
    

    const handleFilterMesFrom = (e:any) => {
        setFechaMinimaTo(new Date(moment(e.value).year(), moment(e.value).month(), 1))
        if(new Date(e.value).getTime() > new Date(filters.month_to).getTime()) {
            setFilters({...filters,month_from:e.value ?? "",month_to:(e.value === null || e.value === "") ? "" : e.value })
        } else {
            setFilters({...filters,month_from:e.value ?? "",month_to:(e.value === null || e.value === "") ? "" : filters.month_to })
        }
        
    }

    const handleFilterMesTo = (e:any) => {
        setFilters({...filters,month_to:e.value ?? ""})
    }

    const handleFilterType = (e:any) => {
        setFilters({...filters,own_foreign:e.value ?? ""})
    }

    const handleDeleteFilters = async() => {
        try {
            setLoadingDeleteFilters(true)
            setFiltersUsedCounter([0,0,0,0,0])
            setSelectedPajeras([])
            setSelectedTransportes([])
            setFilters({
                warehouse: "",
                transport: "",
                month_from: "",
                month_to: "",
                own_foreign: ""
            })
            
            setTimeout(() => {
                setFiltersFlag(!filtersFlag)
                setLoadingDeleteFilters(false)
                setVisible(false)
                success("Filtros restaurados por defecto")
            },3000)
                
            
        } catch(err:any) {
            console.log(err)
            catchResponse(err)
            setLoadingDeleteFilters(false)
        }
        
    }

    
    const handleApplyFilters = async() => {
        try {
            setLoadingApplyFilters(true)
            setTimeout(() => {
                setFiltersFlag(!filtersFlag)
                setLoadingApplyFilters(false)
                setVisible(false)
            },3000)
              
        } catch(err:any) {
            console.log(err)
            catchResponse(err)
            setLoadingApplyFilters(false)
        }
    }

    const headerContent = (
        <div className="filters-header">
            <span>Selector de filtros</span>
        </div>
    )

    const footerContent = (
        <div className="filters-footer">
            <Button severity={'danger'} label="Borrar Filtros" icon={loadingDeleteFilters? <FiCommand className="loading-icon" style={{fontSize:15,marginRight:'1rem',color:'red'}} /> : <AiFillDelete style={{fontSize:20}} />} onClick={handleDeleteFilters} disabled={loadingApplyFilters || loadingDeleteFilters || (filters.transport === "" && filters.warehouse === "" && filters.month_from === "" && filters.month_to === "" && filters.own_foreign === "")}  outlined />
            <Button severity={'success'} label="Aplicar Filtros" icon={loadingApplyFilters? <FiCommand className="loading-icon" style={{fontSize:15,marginRight:'1rem',color:'#22C55E'}} /> : <BsFillFilterCircleFill style={{fontSize:20,marginRight:'1rem'}} />} disabled={loadingApplyFilters || loadingDeleteFilters|| ((filters.month_from === "" && filters.month_to !== "") || (filters.month_from !== "" && filters.month_to === "") )} onClick={handleApplyFilters}  outlined />

        </div>
    );

    
    const fetchFilterOptionsByScenarioID = async() => {
        try {
            const res = await getFilterOptionsByScenarioID(id,id_compare)
            if(res.status === 200) {
                const { code,data} = res.data
               
                if(code === 200) {
                    
                    const { transport, warehouse } = data
                    
                    setFilteredItemsTransporte(transport?.map((t:any) => ({code:t.id_transport,name:t.name_transport})))
                    setItemsTransporte(transport?.map((t:any) => ({code:t.id_transport,name:t.name_transport})))
                    setFilteredItemsPajera(warehouse?.map((w:any) => ({code:w.id_warehouse,name:w.name_warehouse})))
                    setItemsPajera(warehouse?.map((w:any) => ({code:w.id_warehouse,name:w.name_warehouse})))
                }
            }
        } catch(err:any) {
            catchResponse(err)
        }
    }


    useEffect(() => {
        fetchFilterOptionsByScenarioID()
    },[idScenario])

    const handleSelectPajera = (e:any) => {
        if(typeof(e.value) === 'object') {
            setSelectedPajera(null)
            let aux = selectedPajeras

            let exists = aux.find((pajera:any) => pajera.code === e.value.code)

            if(exists) {
                let lista_filtrada = aux.filter((lf:any) => lf.code !== e.value.code)
                setSelectedPajeras(lista_filtrada)
                setFilters({...filters,warehouse:e.value?.length === 0 || e.value === ""? "" : lista_filtrada.length === 0? "" : lista_filtrada})

                
            } else {
                aux.push(e.value)
                setSelectedPajeras(aux)
                setFilters({...filters,warehouse:e.value?.length === 0 || e.value === ""? "" : aux})

                
            }
            
            

        } else {
            setSelectedPajera(e.value)
        }

        
  
    }

    const handleDeletePajera = (code:any) => {
        
        let aux = selectedPajeras
        let lista_filtrada = aux.filter((lf:any) => lf.code !== code)
        
        setSelectedPajeras(lista_filtrada)
        setFilters({...filters,warehouse:lista_filtrada.length === 0? "" : lista_filtrada})
        
    }

    const handleSelectTransporte = (e:any) => {
        if(typeof(e.value) === 'object') {
            setSelectedTransporte(null)
            let aux = selectedTransportes

            let exists = aux.find((transport:any) => transport.code === e.value.code)

            if(exists) {
                let lista_filtrada = aux.filter((lf:any) => lf.code !== e.value.code)
                setSelectedTransportes(lista_filtrada)
                setFilters({...filters,transport:e.value?.length === 0 || e.value === ""? "" : lista_filtrada.length === 0? "" : lista_filtrada})

                
            } else {
                aux.push(e.value)
                setSelectedTransportes(aux)
                setFilters({...filters,transport:e.value?.length === 0 || e.value === ""? "" : aux})

                
            }
            
            

        } else {
            setSelectedTransporte(e.value)
        }
        
    }

    const handleDeleteTransporte = (code:any) => {
        
        let aux = selectedTransportes
        let lista_filtrada = aux.filter((lf:any) => lf.code !== code)
        
        setSelectedTransportes(lista_filtrada)
        setFilters({...filters,transport:lista_filtrada.length === 0? "" : lista_filtrada})
        
    }

    const handleClose = () => {
        setFilters(filtersMASTER)
        setSelectedPajeras(filtersMASTER.warehouse !== ""? filtersMASTER.warehouse : [])
        setSelectedTransportes(filtersMASTER.transport !== ""? filtersMASTER.transport : [])
        setVisible(false)
    }
    
  
    return (
        <div className="card flex justify-content-center">
            <Dialog header={headerContent} visible={visible} style={{ width: '50vw' }} onHide={handleClose} footer={footerContent}>
                <div className="filters-modal-container">
                
                    <div className="card flex justify-content-center">
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="pajera">Pajera <FaSquare color="var(--lis-dark)" /></label>
                        <div style={{display:'flex',maxHeight:75,minHeight:75}}>
                            <AutoComplete disabled= {loadingApplyFilters || loadingDeleteFilters } field="name" style={{width:190,minWidth:190,marginRight:'1rem',maxHeight:45}}  value={selectedPajera} suggestions={filteredItemsPajera} completeMethod={searchPajera} onChange={handleSelectPajera} />
                            <div style={{overflowY:'auto',overflowX:'hidden'}} >
                               {
                                    selectedPajeras.map((sp:any,index:number) => {
                                        return <Chip style={{fontSize:'0.7rem',margin:'0.25rem', cursor:'pointer',backgroundColor:'var(--lis-dark)',color:'white',fontFamily:'var(--roboto-light)'}} key={index} label={sp.name} onClick={() => handleDeletePajera(sp.code)}/>
                                    })
                                }
                            </div> 
                                
                        </div>
                    </div>
                            
                    <div className="card flex justify-content-center">
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="transporte">Transporte <FaSquare color="var(--lis-alternative)" /></label>
                        <div style={{display:'flex',maxHeight:75,minHeight:75}}>
                            <AutoComplete disabled= {loadingApplyFilters || loadingDeleteFilters } field="name" style={{width:190,minWidth:190,marginRight:'1rem',maxHeight:45}}  value={selectedTransporte} suggestions={filteredItemsTransporte} completeMethod={searchTransporte} onChange={handleSelectTransporte} />
                            <div style={{overflowY:'auto',overflowX:'hidden'}} >
                               {
                                    selectedTransportes.map((st:any,index:number) => {
                                        return <Chip style={{fontSize:'0.7rem',margin:'0.25rem', cursor:'pointer',backgroundColor:'var(--lis-alternative)',color:'white',fontFamily:'var(--roboto-light)'}} key={index} label={st.name}  onClick={() => handleDeleteTransporte(st.code)} />
                                    })
                                }
                            </div> 
                                
                        </div>
                    </div>

                    <div className="card flex justify-content-center">
                        
                        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
                            <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="month-from">Desde</label>
                            <Calendar locale="es" minDate={fechaMinima} maxDate={fechaMaxima} inputId="month-from" value={filters.month_from} onChange={handleFilterMesFrom} view="month" dateFormat="mm/yy" disabled= {loadingApplyFilters || loadingDeleteFilters} />
                            <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="month-to">Hasta</label>
                            <Calendar locale="es" minDate={fechaMinimaTo} maxDate={fechaMaxima} inputId="month-to" value={filters.month_to} onChange={handleFilterMesTo} view="month" dateFormat="mm/yy" disabled= {loadingApplyFilters || loadingDeleteFilters || filters.month_from === ""} />
                        </div>
                        {
                            filters.month_from !== "" || filters.month_to !== ""?
                                <small style={{minHeight:20,color:'red',fontFamily:'var(--roboto-heavy)',marginTop:5}}>**Los filtros de rango temporal no afectan a algunos KPIS**</small>
                            :
                                <small  style={{minHeight:20,marginTop:5}}></small>
                        }
                        
                    </div>

                    <div className="card flex justify-content-center">
                        <SelectButton value={filters.own_foreign} onChange={handleFilterType} options={options} disabled= {loadingApplyFilters || loadingDeleteFilters } />
                    </div>

                </div>
                
            </Dialog>
        </div>
    )
}